import { css } from "@emotion/css";
import { useObservableState, useSubscription } from "observable-hooks";
import { includes } from "ramda";
import React, { FC, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { animated, useSpring } from "react-spring";
import { useDrag } from "react-use-gesture";
import { combineLatest } from "rxjs";
import { filter, map, tap } from "rxjs/operators";
import { generateInitialNotes } from "../../state/data/init";
import { InnerNote } from "../InnerNote";
import { destinations$ } from "./Placeholder";
import {
  drag$,
  dragEnds$,
  isDragging$,
  lastDraggedNoteId$,
  DraggingEvent,
  DragStartEvent,
  DragEndEvent,
  placeholderDimensions$,
} from "./Control";

export const DELTA_Y_WHILE_DRAGGING = 25;
export const DELTA_X_WHILE_DRAGGING = 25;

export const DraggedNote: FC<{ starting: DOMRect; noteId: string }> = ({
  starting,
  noteId,
}) => {
  const [destination, setDestination] =
    useState<HTMLDivElement | undefined>(undefined);

  const [props, set] = useSpring(() => ({
    x: starting.x,
    y: starting.y,
    scale: 1,
    height: starting.height,
    width: starting.width,
  }));

  /* Animation subs */
  useSubscription(
    drag$.pipe(
      filter((e): e is DraggingEvent => e.type === "DRAGGING")
      // map((e) => ({ x: e.gevent.xy[0], y: e.gevent.xy[1] }))
    ),
    (e) => {
      set({
        x: e.gevent.xy[0] - DELTA_X_WHILE_DRAGGING,
        y: e.gevent.xy[1] - DELTA_Y_WHILE_DRAGGING,
        // scale: 5,
        immediate: true,
      });
    }
  );

  useSubscription(destinations$, (d) => {
    setDestination(d);
    if (d !== undefined) {
      set({
        height: d.getBoundingClientRect().height,
        width: d.getBoundingClientRect().width,
      });
    }
  });

  useSubscription(placeholderDimensions$, (e) => {
    set({
      height: e.height,
      width: e.width,
    });
  });

  useSubscription(dragEnds$, (e) => {
    const to =
      destination && destination.clientHeight > 0
        ? {
            x: destination.getBoundingClientRect().x,
            y: destination.getBoundingClientRect().y,
          }
        : {
            x: starting?.x,
            y: starting?.y,
            height: starting?.height,
            width: starting?.width,
          };
    set({
      ...to,
      onRest: () => {
        console.log("Animating ends ---------------------");
        console.log({ type: "DONE_ANIMATING", id: noteId! });
        drag$.next({ type: "DONE_ANIMATING", id: noteId! });
      },
    });
  });

  return (
    <div
      className={css`
        cursor: grabbing;
      `}
    >
      <animated.div
        className={css`
          position: absolute;
          pointer-events: none;
        `}
        style={{ ...props }}
      >
        <InnerNote
          id={noteId!}
          bind={() => ({})}
          dragged={true}
          controlledHeight={false}
        />
      </animated.div>
    </div>
  );
};
